import { Box, Tab, Tabs } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import MainContainer from '../../layout/MainContainer';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Payment = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [valueTabs, setValueTabs] = React.useState(0);
  const [hidden, setHidden] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const rows = [
    {
      id: 1,
      image: '/static/images/shipping_02.jpg',
      mode: 'Online',
      date: '27 Feb 2025',
      status: 'Accepted',
      amount: 'AED 2343',
    },
    {
      id: 2,
      image: '/static/images/shipping_02.jpg',
      mode: 'Online',
      date: '27 Feb 2025',
      status: 'Pending',
      amount: 'AED 2343',
    },
    {
      id: 3,
      image: '/static/images/shipping_02.jpg',
      mode: 'Cash',
      date: '27 Feb 2025',
      status: 'Rejected',
      amount: 'AED 2343',
    },
    {
      id: 4,
      image: '/static/images/shipping_02.jpg',
      mode: 'UPI',
      date: '27 Feb 2025',
      status: 'Accepted',
      amount: 'AED 3243',
    },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'userDetails',
      headerName: 'User details',
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate('/profile-detail/individual')}>
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> +9203024595467 <br />
              emma@gmail.com
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'amount',
      headerName: 'Amount Received',
      editable: false,
      sortable: false,
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: 'date',
      headerName: 'Payment Received On',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'mode',
      headerName: 'Payment Mode',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'status',
      headerName: 'Payment Status',
      editable: false,
      sortable: false,
    },
  ];

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1> Payment</h1>
          <p>
            <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Payment
          </p>
        </div>
        {/* <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate("add")}>
            Add Brand
          </Button>
        </div> */}
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search Payment"
                />
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Marketing (10)" {...a11yProps(0)} />
            <Tab label="Inspection (10)" {...a11yProps(1)} />
            <Tab label="Featured ads (10)" {...a11yProps(2)} />
            <Tab label="Listings (10)" {...a11yProps(2)} />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={0}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <div className="sorting_table">
              <TableComponent
                columns={columns?.filter((item: any) => !hidden.includes(item.field))}
                rows={rows}
              />
            </div>
          </CustomTabPanel>
        </Box>
      </div>
    </MainContainer>
  );
};

export default Payment;
